import { type Node, type NodeProps } from '@xyflow/react'
import { memo } from 'react'

import { GraphColors } from '../../../bpmn-graph.constants'
import { NavAreaNodeData } from '../bpmn-graph.mapper'

/**
 * Navigation area overlay — translucent grey rounded rect
 * with the area label at its bottom-left; selected areas get the blue treatment.
 */
function NavAreaNode({ data }: NodeProps<Node<NavAreaNodeData>>) {
  const { area } = data
  const { width, height } = area.layoutOptions

  return (
    <div
      data-testid={`nav-area-${area.id}`}
      style={{
        width,
        height,
        borderRadius: 4,
        background: area.selected ? GraphColors.blue_500_20 : GraphColors.neutral_600_20,
        border: area.selected ? `1px solid ${GraphColors.blue_500}` : 'none',
        position: 'relative',
        pointerEvents: 'none',
      }}
    >
      <span
        style={{
          position: 'absolute',
          bottom: 4,
          left: 8,
          fontSize: 10,
          fontWeight: 600,
          fontFamily: 'Open Sans, sans-serif',
          color: GraphColors.neutral_700,
          whiteSpace: 'nowrap',
        }}
      >
        {area.label}
      </span>
    </div>
  )
}

export default memo(NavAreaNode)
